import { BoxShopSalesEntity } from "@/modules/boxShop/entities/boxShopSalesEntity"
import type { BoxShopSalesFormValues } from "@/modules/boxShop/form/boxShopFormik"
import type { BoxShopSalesMailDto, BoxShopSalesResultDto } from "@/modules/boxShop/gateway/boxShopSalesApiDto"
import { BOX_SHOP_ITEMS_QUERY_KEY } from "@/modules/boxShop/hooks/useBoxShopItem"
import { useServicesContext } from "@/modules/core/services/services.context"
import { financeKeys } from "@/modules/finances/gateway/financeKeys"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useBoxShopSalesCreate() {
  const { boxShopSalesApi } = useServicesContext()
  const queryClient = useQueryClient()
  const { mutateAsync: createSale, isPending: isPendingCreateSale } = useMutation<
    BoxShopSalesResultDto,
    Error,
    BoxShopSalesFormValues
  >({
    mutationFn: async (values: BoxShopSalesFormValues) =>
      await boxShopSalesApi.createSale(BoxShopSalesEntity.fromFormikToInputDto(values)),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [BOX_SHOP_ITEMS_QUERY_KEY] })
      await queryClient.invalidateQueries({ queryKey: financeKeys.all })
    },
  })
  return {
    createSale,
    isPendingCreateSale,
  }
}

export function useBoxShopSalesSendEmail() {
  const { boxShopSalesApi } = useServicesContext()
  const { mutateAsync: sendEmail, isPending: isSendEmailLoading } = useMutation<
    unknown,
    Error,
    { saleId: string; input: BoxShopSalesMailDto }
  >({
    mutationFn: async ({ saleId, input }: { saleId: string; input: BoxShopSalesMailDto }) => {
      await boxShopSalesApi.sendEmail(saleId, input)
    },
  })
  return {
    sendEmail,
    isSendEmailLoading,
  }
}
